export const CATEGORIES = {
  CHECKOUT: {
    CATEGORY: 'Checkout',
    LABELS: {
      CREDIT_CARD_ACCEPTED: 'Credit Card - Accepted',
      CREDIT_CARD_DECLINED: 'Credit Card - Declined',
      REFERENCE_CODE_GENERATED: 'Reference Code Generated',
      VIEW_LINK_DETAILS: 'View Link Details',
      CHECKOUT_BYLINE: 'Checkout Byline',
      SUCCESS_SCREEN_CTA: 'Success Screen CTA',
    },
  },
};

export const ACTIONS = {
  SUBMIT: 'Submit',
  CLICK: 'Click',
};
